// @writing-suite/core/review: beta-reader links (design §2.7, PROTOCOL.md §7) — the Swift's review values, copies made
// from a checkpoint, notes placed as comments at the checkpoint's heads, progress, and the web's reader rounds.
export {
  decodeReaderProgress, decodeReviewCopy, decodeReviewNote, encodeReaderProgress, encodeReviewCopy, encodeReviewNote, makeReviewCopy,
  reviewCopyTitle, ReviewError, type ReaderProgress, type ReviewCopy, type ReviewCopySection, type ReviewNote,
} from './copy.ts';
export {
  encodeStoredProgress, MAX_AUTHOR, MAX_BODY, MAX_QUOTE, placeComment, placeReviewNotes, progressKey, storedProgress,
  type IncomingNote, type IncomingProgress, type PlacedComment, type PlacedReview, type PlaceResult,
} from './place.ts';
export { decodeWebRound, encodeWebRound, putWebRound, webLinks, webRounds, WEB_ROUNDS_KEY, type WebReader, type WebReaderRound } from './rounds.ts';
export { fromISO8601, fromReferenceSeconds, REFERENCE_DATE_OFFSET, ReviewDataError, toISO8601, toReferenceSeconds } from './json.ts';
